import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseTextInput, type BaseTextInputProps } from './BaseTextInput';

export type TextInputProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseTextInputProps,
	'hasError' | 'name' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

/**
 *
 * @param {TextInputProps} props - The component's props
 * @param {string} label - label to display
 * @param {string} children - use this in case label is not enough
 * @param {string} defaultChecked - initial checked state
 * @param {string} disabled - is the checkbox disabled
 * @param {boolean} isOnError - can be used to activate the on-error style
 * @param {function} onChange - on box click change callback
 */
export function TextInput<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: TextInputProps<T, FP>) {
	const {
		field,
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseTextInput {...field} error={error} {...props} />;
}
